'use client';

import { type PropsWithChildren, useEffect, useState } from 'react';
import { Button as TooltipButton, TooltipTrigger } from 'react-aria-components';

import { TooltipBase, type TooltipPlacement } from './TooltipBase';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { InfoIcon } from '@fagmobler/ui';

type Props = PropsWithChildren & {
  isOpen?: boolean;
  className?: string;
  placement?: TooltipPlacement;
  size?: 'small' | 'large';
  trigger?: 'focus';
};

export const Tooltip = ({
  isOpen: isManualOpen,
  className = '',
  trigger,
  ...rest
}: Props) => {
  const [isOpen, setIsOpen] = useState<undefined | true>(undefined);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(undefined);
    }, 2500);

    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <TooltipTrigger
      trigger={trigger}
      closeDelay={0}
      delay={0}
      isOpen={isManualOpen || isOpen}
    >
      <TooltipButton
        onPress={() => setIsOpen(true)}
        className={twMerge(
          clsx(
            'cursor-pointer focus-visible:outline-none rounded lg:w-fit',
            className
          )
        )}
      >
        <InfoIcon className="size-4 shrink-0 text-neutral-80" />
      </TooltipButton>
      <TooltipBase {...rest} />
    </TooltipTrigger>
  );
};
